<app-simple-string-value-accessor label="Email"
                                  [formControl]="emailForm"
                                  required="true"></app-simple-string-value-accessor>
<div class="actions">
  <button mat-raised-button
          class="width-100"
          action-button
          [disabled]="emailForm.invalid"
          color="primary"
          type="button"
          [action]="addEmail.bind(this)">
    Dodaj email
  </button>
</div>
